import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface FileInfo {
  id: string;
  name: string;
  size: number;
  type: string;
  url?: string;
  // Add more fields as needed
}

export interface FilesMapState {
  files: Record<string, FileInfo>;
}

const initialState: FilesMapState = {
  files: {},
};

const filesMapSlice = createSlice({
  name: 'filesMap',
  initialState,
  reducers: {
    addFile: (state, action: PayloadAction<FileInfo>) => {
      state.files[action.payload.id] = action.payload;
    },
    removeFile: (state, action: PayloadAction<string>) => {
      delete state.files[action.payload];
    },
    setFiles: (state, action: PayloadAction<Record<string, FileInfo>>) => {
      state.files = action.payload;
    },
    clearFiles: (state) => {
      state.files = {};
    },
  },
});

export const { addFile, removeFile, setFiles, clearFiles } = filesMapSlice.actions;
export default filesMapSlice.reducer;